module.exports = __webpack_public_path__ + "img/logo-text-techpaf-blanc.c072674f.png";